import type { PlaybackEndpoints } from '@amzn/bf-playback'
import { resolvedTerritory } from '@/resolvedTerritory'
import { MARKETPLACE_TLDS, musicTld } from '@/territory'
import { IS_TAURI } from '@/util/platform'
import { getApiHost, getDmlsHost, useLiveHost } from '@/service/useLiveHost'

const METRIX_EVENTS_PATH = '/telemetry/v1/events'

// The SDK's `amtcBaseEndpoint`: these marketplaces serve telemetry under `/ZAZ`.
function usesZazPrefix(tld: string): boolean {
    return ['co.uk', 'de', 'es', 'fr', 'it', 'in'].includes(tld)
}

/** The `music.amazon.<tld>` marketplace the page itself is served from, as the SDK's window host. */
function pageMusicTld(): string | undefined {
    if (typeof location === 'undefined') return undefined
    const tld = location.hostname.match(/^music\.amazon\.(.+)$/)?.[1]
    return tld && MARKETPLACE_TLDS.includes(tld) ? tld : undefined
}

// A browser origin that neither proxies nor is a music.amazon.<tld> page sends the cross-origin
// preflight music.amazon.<tld> refuses (403, no allow-origin).
function canUploadMetrix(): boolean {
    return IS_TAURI || !useLiveHost() || pageMusicTld() !== undefined
}

export const webPlaybackEndpoints: PlaybackEndpoints = {
    apiHost: getApiHost,
    dmlsHost: getDmlsHost,
    pageOrigin: () => location.origin,
    pageUrl: () => location.href,
    canUploadMetrix,
    metrixEventsUrl: () => {
        if (!useLiveHost()) return `${getApiHost()}${METRIX_EVENTS_PATH}`
        const tld = pageMusicTld() ?? musicTld(resolvedTerritory())
        return `https://music.amazon.${tld}${usesZazPrefix(tld) ? '/ZAZ' : ''}${METRIX_EVENTS_PATH}`
    },
}
